// import React, { useState, useRef } from "react";

// export default function HomeMap() {
//   const countryData = {
//     INDIA: {
//       locations: [
//         {
//           flag: "/assets/images/india-flag-inner.webp",
//           city: "India",
//           address: "205, Vipul Square, <br> Sushant Lok-1, Gurgaon, <br> Haryana, India, 122002.",
//           phone: "+91-124-4807600",
//           email: "contact@supershine.in",
//         },
//       ],
//     },
//     UAE: {
//       locations: [
//         {
//           flag: "/assets/images/uae-flag.webp",
//           city: "UAE",
//           address: "Supershine Equipment Trading LLC <br> Plot No – 518-0, Office No – 7 <br> Al Garhoud, Dubai, UAE.",
//           phone: "+971-04-3519616",
//           email: "contact@supershinelaundry.ae",
//         },
//       ],
//     },
//     AFRICA: {
//       locations: [
//         {
//           flag: "/assets/images/nigeria-flag.webp",
//           city: "Africa",
//           address: "Supershine Systems Limited <br> Banglow No 11, Hassan Estate <br> Dakata,   Kano, Nigeria.",
//           phone: "+234 704 020 0021",
//           email: "contact@supershinelaundry.ae",
//         },
//       ],
//     },
//   };

//   // Create a flat list of all locations with country info
//   const allLocations = Object.keys(countryData).flatMap(country =>
//     countryData[country].locations.map(loc => ({ ...loc, country }))
//   );

//   const [activeIndex, setActiveIndex] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//   const intervalRef = useRef(null);

//   const activeLocation = allLocations[activeIndex];
//   const activeCountry = activeLocation.country;

//   // Autoplay with pause on hover
//   // useEffect(() => {
//   //   clearInterval(intervalRef.current);

//   //   if (!isHovered && allLocations.length > 1) {
//   //     intervalRef.current = setInterval(() => {
//   //       setActiveIndex(prev => (prev === allLocations.length - 1 ? 0 : prev + 1));
//   //     }, 20000);
//   //   }

//   //   return () => clearInterval(intervalRef.current);
//   // }, [isHovered, allLocations.length]);

//   // Handle manual navigation
//   const prevSlide = () => {
//     setActiveIndex(prev => (prev === 0 ? allLocations.length - 1 : prev - 1));
//   };

//   const nextSlide = () => {
//     setActiveIndex(prev => (prev === allLocations.length - 1 ? 0 : prev + 1));
//   };

//   // Handle country click
//   const handleCountryClick = country => {
//     const index = allLocations.findIndex(loc => loc.country === country);
//     if (index !== -1) setActiveIndex(index);
//   };

//   return (
//     <section className="home-map">
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-md-12 col-lg-8">
//             <div className="map-text center-heading">
//               <h3 className="heading">Expanding Our Reach Across Globe</h3>
//             </div>
//           </div>
//         </div>

//         {/* Country List */}
//         <div className="country-list">
//           {Object.keys(countryData).map(country => (
//             <span key={country} className={`country ${activeCountry === country ? "active" : ""}`} onClick={() => handleCountryClick(country)} >
//               <img src={countryData[country].locations[0].flag} alt={country} />
//               {country}
//             </span>
//           ))}
//         </div>

//         {/* Slider Section */}
//         <div className="row align-items-end">
//           <div
//             className="col-sm-6 col-md-7 col-lg-9"
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}  >
//             <div className="location-video">
//               <img src="/assets/gif/map-gif.gif" alt="Global Presence" className="map-image" />
//             </div>
//           </div>

//           <div className="col-sm-6 col-md-5 col-lg-3">
//             <div className="address-card slider-animate">
//               <div className="address-sec">
//                 <div className="address-title">
//                   <img src={activeLocation.flag} alt={activeLocation.city} />
//                   {activeLocation.city}
//                 </div>

//                 {allLocations.length > 1 && (
//                   <div className="slider-controls">
//                     <button className="location-left" onClick={prevSlide}>
//                       <i className="fa-solid fa-arrow-left"></i>
//                     </button>
//                     <button className="location-right" onClick={nextSlide}>
//                       <i className="fa-solid fa-arrow-right"></i>
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <p className="address-paragraph" dangerouslySetInnerHTML={{ __html: activeLocation.address }} />


//               {activeLocation.email && (
//                 <div className="email-wrapper">
//                   <i className="fa-solid fa-envelope"></i>
//                   <a href={`mailto:${activeLocation.email}`}>
//                     {activeLocation.email}
//                   </a>
//                 </div>
//               )}

//               {activeLocation.phone ? (
//                 <p className="phone">
//                   <i className="fa-solid fa-phone"></i>
//                   <a   href={`tel:${activeLocation.phone.replace(/\s+/g, "")}`}  >
//                     {activeLocation.phone}
//                   </a>
//                 </p>
//               ) : (
//                 <div className="phone blank"></div>
//               )}

//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }



// import React, { useState } from "react";
import React, { useEffect, useRef, useState } from "react";

export default function HomeMap() {
  const countryData = {
    INDIA: {
      locations: [
        {
          flag: "/assets/images/india-flag-inner.webp",
          city: "India",
          address:
            "Vipul Square, 205, 2nd Floor, B Block, <br/> Sushant Lok Phase I, Gurgaon, <br> Haryana, India.",
          phone: "+91-124-4807600",
          email: "sales@supershinelaundry.ae",
        },
      ],
    },

    UAE: {
      locations: [
        {
          flag: "/assets/images/uae-flag.webp",
          city: "UAE",
          address:
            "Supershine Laundry  Equipment Trading LLC <br> Plot No – 518-0, Office No – 7 <br> Al Garhoud, Dubai, UAE.",
          phone: "+971-04-3519616",
          email: "contact@supershinelaundry.ae",
        },
      ],
    },

    AFRICA: {
      locations: [
        {
          flag: "/assets/images/nigeria-flag.webp",
          city: "Africa",
          address:
            "Supershine Systems Limited <br> Banglow No 11, Hassan Estate <br> Dakata, Kano, Nigeria.",
          phone: "+234 704 020 0021",
          email: "contact@supershinelaundry.ae",
        },
      ],
    },
  };

  // Countries Array
  const countries = Object.keys(countryData);

  // Active Country Index
  const [activeIndex, setActiveIndex] = useState(0);
  const [shouldLoadMap, setShouldLoadMap] = useState(false);
  const mapContainerRef = useRef(null);




//   useEffect(() => {

//     const getLocation = async () => {

//         try {

//             const res = await fetch("https://api.country.is/");

//             const data = await res.json();

//             const country = data.country;

//             let selectedCountry = "INDIA";

//             if (["AE", "FR"].includes(country)) {
//                 selectedCountry = "UAE";
//             }
//             else if (["ZA", "NG", "KE", "SG"].includes(country)) {
//                 selectedCountry = "AFRICA";
//             }

//             const index = countries.indexOf(selectedCountry);

//             if (index !== -1) {
//                 setActiveIndex(index);
//             }

//         } catch (error) {

//             console.log("Geo fetch failed", error);

//         }

//     };

//     getLocation();

// }, []);


useEffect(() => {

    const getLocation = async () => {

        try {

            const res = await fetch(
                "https://api.ipinfo.io/lite/me?token=97284bd34c77fb"
            );

            const data = await res.json();

            const country = data.country;

            let selectedCountry = "INDIA";

            if (["AE", "FR", "UK", "GB"].includes(data.country_code)) {
                selectedCountry = "UAE";
            }
            else if (["ZA", "NG", "KE", "SG", "ES"].includes(data.country_code)) {
                selectedCountry = "AFRICA";
            }

            const index = countries.indexOf(selectedCountry);

            if (index !== -1) {
                setActiveIndex(index);
            }

        } catch (error) {

            console.log("IPInfo fetch failed", error);

        }

    };

    const scheduleLocationLookup = () => {
        if (typeof window !== "undefined" && "requestIdleCallback" in window) {
            return window.requestIdleCallback(getLocation, { timeout: 3000 });
        }

        return setTimeout(getLocation, 1200);
    };

    const lookupId = scheduleLocationLookup();

    return () => {
        if (typeof window !== "undefined" && "cancelIdleCallback" in window) {
            window.cancelIdleCallback(lookupId);
            return;
        }

        clearTimeout(lookupId);
    };

}, []);

useEffect(() => {
    if (shouldLoadMap) {
        return;
    }

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
        setShouldLoadMap(true);
        return;
    }

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setShouldLoadMap(true);
                observer.disconnect();
            }
        },
        { rootMargin: "600px 0px" }
    );

    if (mapContainerRef.current) {
        observer.observe(mapContainerRef.current);
    }

    return () => observer.disconnect();
}, [shouldLoadMap]);







  // Active Country
  const activeCountry = countries[activeIndex];

  // Active Location
  const activeLocation =
    countryData[activeCountry].locations[0];

  // Previous Slide
  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? countries.length - 1 : prev - 1
    );
  };

  // Next Slide
  const nextSlide = () => {
    setActiveIndex((prev) =>
      prev === countries.length - 1 ? 0 : prev + 1
    );
  };

  // Country Click
  const handleCountryClick = (country) => {
    const index = countries.indexOf(country);

    if (index !== -1) {
      setActiveIndex(index);
    }
  };

  return (
    <section className="home-map">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="map-text center-heading">
              <h3 className="heading">
                Expanding Our Reach Across Globe
              </h3>
            </div>
          </div>
        </div>

        {/* Country List */}
        <div className="country-list">
          {countries.map((country) => (
            <span    key={country}  className={`country ${   activeCountry === country ? "active" : ""   }`}  onClick={() => handleCountryClick(country)}  >
              <img  src={  countryData[country].locations[0].flag   }   alt={country} loading="lazy" decoding="async" width="40" height="40"   />
              {country}
            </span>
          ))}
        </div>
        {/* Slider Section */}
        <div className="row align-items-end">
          {/* Map */}
          <div className="col-sm-6 col-md-7 col-lg-9">
            <div className="location-video" ref={mapContainerRef}>
              {shouldLoadMap ? (
                <img   src="/assets/gif/map-gif.gif" alt="Global Presence"    className="map-image" loading="lazy" decoding="async" fetchPriority="low" width="1080" height="540"  />
              ) : (
                <div className="map-image" style={{ aspectRatio: "2 / 1", width: "100%" }} aria-hidden="true" />
              )}
            </div>
          </div>

          {/* Address Card */}
          <div className="col-sm-6 col-md-5 col-lg-3">
            <div className="address-card slider-animate">
              <div className="address-sec">
                <div className="address-title">
                  <img  src={activeLocation.flag}    alt={activeLocation.city} loading="lazy" decoding="async" width="40" height="40"  />
                  {activeLocation.city}
                </div>
                {/* Slider Controls */}
                <div className="slider-controls">
                  <button  className="location-left"     onClick={prevSlide} >
                    <i className="fa-solid fa-arrow-left"></i>
                  </button>
                  <button className="location-right"   onClick={nextSlide}    >
                    <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
              {/* Address */}
              <p    className="address-paragraph"   dangerouslySetInnerHTML={{
                  __html: activeLocation.address,   }}  />
              {/* Email */}
              {activeLocation.email && (
                <div className="email-wrapper">
                  <i className="fa-solid fa-envelope"></i>
                  <a href={`mailto:${activeLocation.email}`}>
                    {activeLocation.email}
                  </a>
                </div>
              )}
              {/* Phone */}
              {activeLocation.phone && (
                <p className="phone">
                  <i className="fa-solid fa-phone"></i>
                  <a  href={`tel:${activeLocation.phone.replace(   /\s+/g,   ""    )}`}  >
                    {activeLocation.phone}
                  </a>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
